import { FunctionComponent } from 'react';
import classnames from 'classnames';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobBenefits: FunctionComponent<Props> = ({
    headline,
    list,
    icon,
    iconAlt,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-benefits"
        >
            <LayoutContainer size={Sizes.Small}>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <div
                    className={classnames(
                        'list',
                        {
                            longList: list.length > 4,
                        }
                    )}
                >
                    {list.map(element => (
                        <div
                            key={element?.id}
                            className="list-element"
                        >
                            <img
                                className="icon"
                                src={icon}
                                loading="lazy"
                                alt={iconAlt}
                            />
                            <div
                                className="element-content"
                                dangerouslySetInnerHTML={{ __html: element?.name }}
                            />
                        </div>
                    ))}
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobBenefits;